import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the MedicamentsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-medicaments',
  templateUrl: 'medicaments.html',
})
export class MedicamentsPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MedicamentsPage');
  }

  goBack(){
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/medicaments/medicaments.ts